<template>
    <svg class="scalar-chart" :width="width" :height="height" :viewBox="'0 0 '+width+' '+height">
        <text v-for="d in data" text-anchor="middle" :x="chartWidth/2" :y="chartHeight/2">{{numeral(d.sum).format('0,0')}}</text>
    </svg>
</template>
<style lang="scss">
    .scalar-chart{
        text{
            font-size: 60px;
        }

    }
</style>
<script>
    import numeral from 'numeral';

    export default{
        data: function(){
            return {
                width: 825,
                height: 510,
                margin:{
                    left: 100,
                    top: 10,
                    right: 10,
                    bottom: 20
                }
            }
        },
        props:['data', 'dimensions'],
        computed:{
            chartWidth: function(){
                return this.width - this.margin.left - this.margin.right;
            },
            chartHeight: function(){
                return this.height - this.margin.top - this.margin.bottom;
            },

        },
        methods:{
            numeral: numeral
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/Components/Charts/Scalar.vue